import React, {useContext, useEffect, useState} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import SidebarFloatMenu from "../../../SidebarFloatMenu";
import BottomDrawer from "../../../BottomDrawer";
import NotificationsMenu from "./components/NotificationsMenu";
import NotificationSidebarItem from "./components/NotificationSidebarItem";

import list from "api/notification/list";

import {NotificationContext} from "./NotificationContext";
import {SidebarContext} from "../../../../../../SidebarContext";

export const NOTIFICATION_TYPE = {
    IMPORT: 'import',
    ESHOP_SYNCHRONIZATION: 'synchronization',
    USER_CHANGE_ORGANIZATION: 'change_organization',
    QUOTE:'quote'
}

function Notifications(props) {
    const [openNotificationMenu, setOpenNotificationMenu] = useState(false);

    const [selectedNavigationToggle, setSelectedNavigationToggle] = useState(0);

    const [notifications, setNotifications] = useState([]);
    const [notificationsViewed, setNotificationsViewed] = useState([]);
    const [notificationsNotViewed, setNotificationsNotViewed] = useState([]);

    const [notificationsToDisplay, setNotificationsToDisplay] = useState(notifications);

    const [notificationsCount, setNotificationsCount] = useState(0)
    const [notificationsViewedCount, setNotificationsViewedCount] = useState(0);
    const [notificationsNotViewedCount, setNotificationsNotViewedCount] = useState(0);

    const {isMobile} = useContext(SidebarContext);

    // 🤫
    useEffect(() => {
        const konamiCode = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];
        let konamiIndex = 0;

        const handleKeyDown = (event) => {
            if (event.key === konamiCode[konamiIndex]) {
                konamiIndex++;
                if (konamiIndex === konamiCode.length) {
                    console.log('😉🎉');
                    konamiIndex = 0;
                }
            } else {
                konamiIndex = 0;
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    useEffect(() => {
        listNotifications();
    }, []);

    useEffect(() => {
        if (props.retrievedNotifications) {
            setNotifications(props.retrievedNotifications);
        }
    }, [props.retrievedNotifications]);

    useEffect(() => {
        if (props.newNotification) {
            listNotifications();
        }
    }, [props.newNotification]);

    useEffect(() =>  {
        const notViewed = notifications.filter((n) => !n.viewed);
        const viewed = notifications.filter((n) => n.viewed);

        setNotificationsNotViewed(notViewed)
        setNotificationsViewed(viewed)

        setNotificationsCount(notifications.length);
        setNotificationsNotViewedCount(notViewed.length)
        setNotificationsViewedCount(viewed.length)
    }, [notifications])

    // when switch navigation toggle
    useEffect(() => {
        displayNotificationByNavigationToggle();
    }, [selectedNavigationToggle])

    // when new notifications retrieved
    useEffect(() => {
        displayNotificationByNavigationToggle();
    }, [notifications, notificationsViewed, notificationsNotViewed])

    function displayNotificationByNavigationToggle() {
        switch (selectedNavigationToggle) {
            case 0:
            default:
                setNotificationsToDisplay(notifications);
                return;
            case 1:
                setNotificationsToDisplay(notificationsViewed);
                return;
            case 2:
                setNotificationsToDisplay(notificationsNotViewed);
                return;
        }
    }

    function listNotifications() {
        list().then((response) => setNotifications(response))
    }

    return (
        <NotificationContext.Provider value={{
            selectedNavigationToggle,
            reloadNotifications: listNotifications,
            notificationsCount,
            notificationsViewedCount,
            notificationsNotViewedCount,
            setSelectedNavigationToggle,
            notificationsToDisplay
        }}>
            <NotificationSidebarItem
                onClick={() => setOpenNotificationMenu(true)}
                notificationsNotViewedCount={notificationsNotViewedCount}
            />
            {isMobile ? (
                <BottomDrawer
                    open={openNotificationMenu}
                    onClose={() => setOpenNotificationMenu(false)}
                    title={<FormattedMessage id='sidebar.profil.notification.title' />}
                >
                    <NotificationsMenu notificationsToDisplay={notificationsToDisplay} />
                </BottomDrawer>
            ) : (
                <SidebarFloatMenu
                    open={openNotificationMenu}
                    onClose={() => setOpenNotificationMenu(false)}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <NotificationsMenu notificationsToDisplay={notificationsToDisplay} />
                </SidebarFloatMenu>
            )}

        </NotificationContext.Provider>
    );
}

export default connect(state => ({
    retrievedNotifications: state.notification.list.retrieved,
    newNotification: state.notification.list.notification
}))(Notifications);
